import classNames from 'classnames';
import { useField } from 'formik';
import { constants } from '../../../constants';
import { DropDownList, DropDownListItem } from '../../controls/DropDownList';
import { FormError } from '../../controls/FormError';

interface DropDownFieldProps {
    name: string;
    label: string;
    options: DropDownListItem[];
    placeholder?: string;
    required?: boolean;
    wrapperClassName?: string;
    withEmptyValue?: boolean;
    withSearch?: boolean;
    disabled?: boolean;
}

export function DropDownField({
    name,
    label,
    options,
    placeholder = 'Select',
    required,
    wrapperClassName,
    withEmptyValue = false,
    withSearch = false,
    disabled = false,
}: DropDownFieldProps) {
    const [field, meta, helpers] = useField<string | undefined>(name);

    const items: DropDownListItem[] = [
        ...(withEmptyValue ? [{ value: '', text: constants.emptyPlaceholder, selected: !field.value }] : []),
        ...options.map(o => ({ ...o, selected: String(o.value) === field.value })),
    ];

    const handleSelect = (value: string) => {
        helpers.setValue(value || undefined);
    };

    const withError = meta.touched && meta.error;

    return (
        <div className={classNames('data-item-row', wrapperClassName)} onClick={e => e.stopPropagation()}>
            {label && (
                <label className="data-item-col data-item-col-title data-item-capitalize">
                    {label}
                    {required && <span className="text-red"> *</span>}
                </label>
            )}
            <div className="data-item-col">
                <DropDownList
                    className={classNames('form-control', { 'is-invalid': withError })}
                    items={items}
                    onChange={item => handleSelect(String(item.value))}
                    placeholder={placeholder}
                    withSearch={withSearch}
                    disabled={disabled}
                />
                {withError && <FormError message={meta.error} />}
            </div>
        </div>
    );
}
